<template>
  <span>
    <a
      class="button interactive"
      :class="buttonClasses"
      @click="handleClick()"
    >
      {{ label }}
    </a>
  </span>
</template>

<script>
export default {
  props: {
    label: {
      type: String,
      required: false,
      default: "Contact Us",
    },
    buttonClasses: {
      type: String,
      required: false,
      default: "primary",
    },
  },
  data() {
    return {
      showLoginDropDown: false,
      triggeredAuth: false,
    };
  },
  mounted() {
    window.addEventListener("click", this.delegatedContactUs);
  },
  beforeDestroy() {
    window.removeEventListener("click", this.delegatedContactUs);
  },
  methods: {
    handleClick() {
      if (!window.location.href.includes("#contact-us")) {
        window.history.pushState(
          "state obj or string",
          "url",
          window.location.href + "#contact-us"
        );
      }
      this.$store.dispatch("modals/showContactUsMonday");
    },
 
    delegatedContactUs(e) {
      let target = e.target;

      while (target.parentNode) {
        if (target === this.$el) {
          return;
        }

        target = target.parentNode;
      }

    },
  },
  computed: {
    authenticating() {},
  },
};
</script>
